import React, { useEffect, useState } from 'react';
import "./Modal.css";
import rotateIpadScreen from "../Assets/modal_graphics/rotate-ipad-screen.png";
const { blockScreenSizeModal } = require('../config.js');

function Modal() {
  const [showModal, setShowModal] = useState(false);
  const [isFullScreen, setFullScreen] = useState(false);
  const [modalType, setModalType] = useState('none');


  useEffect(() => {
    function handleScreenChange() {
      // Check pseudo fullscreen status
      const isPseudoFullScreen = localStorage.getItem('pseudoFullscreen') === 'true' ||
        document.documentElement.classList.contains('pseudo-fullscreen');

      setFullScreen(isPseudoFullScreen);
      console.log('Fullscreen status changed:', isPseudoFullScreen);

      // Check screen orientation
      //  Priority: orientation first, then size.
      //    - Portrait → show rotate prompt
      //    - Landscape → validate minimum screen size
      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait) {
        setModalType('orientation');
        setShowModal(true);
        return;
      }

      if (window.innerWidth < 850 || window.innerHeight < 500) {
        setModalType('size');
        setShowModal(true);
      } else {
        setModalType('none');
        setShowModal(false);
      }
    }

    // Listen for pseudo fullscreen status changes
    function handlePseudoFullscreenChange(event) {
      handleScreenChange();
    }

    window.addEventListener('resize', handleScreenChange);
    window.addEventListener('pseudoFullscreenChange', handlePseudoFullscreenChange);

    document.addEventListener('DOMContentLoaded', () => {
      document.addEventListener('touchmove', function (e) {
        e.preventDefault();
      }, { passive: false });
    });

    handleScreenChange();


    return () => {
      window.removeEventListener('resize', handleScreenChange);
      window.removeEventListener('pseudoFullscreenChange', handlePseudoFullscreenChange);
    };
  }, []);

  const requestFullScreen = () => {
    localStorage.removeItem('returnedFromTest');
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    htmlElement.classList.add('pseudo-fullscreen');
    bodyElement.classList.add('pseudo-fullscreen');
    localStorage.setItem('pseudoFullscreen', 'true');
    const event = new CustomEvent('pseudoFullscreenChange', {
      detail: { isFullScreen: true }
    });
    window.dispatchEvent(event);
  }


  if (!showModal) {
    // Feature preserved but disabled - set to true and specify page path to enable
    const isInGamePage = false; // e.g., location.pathname === '/ThankYou'
    const shouldShowReturnPrompt =
      isInGamePage && !isFullScreen && blockScreenSizeModal !== 'true';
    if (shouldShowReturnPrompt) {
      return (
        <div className="modal">
          <div className="message" data-testid="screen_message" onClick={requestFullScreen}>
            Touch here to return to game❗️
          </div>
        </div>
      );
    }
    return null;
  }

  if (modalType === 'orientation') {
    return (
      <div className="modal">
        <div className="message" data-testid="screen_message">
          <div className="orientation-content">
            <p>Please rotate screen to landscape position</p>
            <img
              src={rotateIpadScreen}
              alt="Please rotate screen to landscape position"
              className="orientation-image"
            />
          </div>
        </div>
      </div>
    );
  }

  // Default: size-based message for small landscape screens
  return (
    <div className="modal">
      <div className="message" data-testid="screen_message">
        Please consider a larger device for the test
      </div>
    </div>
  );
}

export default Modal;
